<template>
  <b-container fluid>
    <b-row class="mb-3">
      <b-col cols="12">
        <PageHeader :title="$cte('companies.title')" :enable-back-link="true" />
      </b-col>
    </b-row>
    <b-row class="mb-3 font-jumper">
      <b-col cols="12">
        <span class="description-text">{{
          $cte("companies.description")
        }}</span>
      </b-col>
    </b-row>
    <b-row class="font-jumper">
      <b-col
        cols="12"
        class="mb-3"
        v-for="(company, index) in getCompanyList"
        :key="'company-' + index"
      >
      <b-button
          variant="primary"
          class="w-100 text-left py-3"
          @click="selectCompany(company)"
        >
          <div class="button-content">
            <div class="icon-wrapper mr-3">
              <span
                class="company-icon"
                :style="'background-color:' + company.color"
              >
                {{ getFirstChar(company.name) }}
              </span>
            </div>
            <div class="link-text">
              {{ getNCharsOfStr(company.name, companyNameDisplayLength) }}
            </div>
          </div>
        </b-button>
      </b-col>

      <b-col cols="12" class="mb-3">
        <b-button
          variant="primary"
          class="w-100 text-left py-3 add-new-company"
          @click="addNewCompany"
        >
          <div class="button-content">
            <div class="icon-wrapper mr-3">
              <span class="">
                <i class="fas fa-plus"></i>
              </span>
            </div>
            <div class="_link-text">{{ $cte("companies.addNewCompany") }}</div>
          </div>
        </b-button>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import PageHeader from "@/components/PageHeader";
import { mapGetters } from "vuex";

export default {
  name: "Companies",
  components: {
    PageHeader,
  },
  data() {
    return {
      companyNameDisplayLength: 30,
    };
  },
  methods: {
    getNCharsOfStr(str, length) {
      if (str) {
        if (str.length > length) {
          return str.substring(0, length) + "...";
        } else {
          return str;
        }
      } else {
        return str;
      }
    },

    getFirstChar(str) {
      return str.charAt(0);
    },

    selectCompany(company) {
      this.$store.dispatch("app/changeActiveCompany", company);
      this.$router.push("/app/home");
    },

    addNewCompany() {
      this.$router.push("/app/company/add");
    },
  },
  computed: {
    ...mapGetters("app", ["getCompanyList"]),
  },
};
</script>

<style lang="scss" scoped>
.btn-light {
  color: #212529;
  background-color: #ffffff;
  border-color: #ffffff;

  &:hover {
    color: #212529;
    background-color: #e2e6ea;
    border-color: #dae0e5;
  }
}

.button-content {
  display: flex;
  align-items: center;
}

.icon-wrapper {
  display: inline-block;
  text-align: center;
}

.description-text {
  color: #b5b5c3;
}

.link-text {
  display: inline-block;
  font-size: 1.2rem;
  font-weight: 600;
}

.company-icon {
  display: inline-block;
  color: #ffffff;
  padding: 0px 7px;
  width: 30px;
  height: 30px;
  font-size: 12px;
  border-radius: 50%;
}

.add-new-company {
  .company-icon {
    color: #b5b5c3;
    border: solid 1px #b5b5c3;
    padding: 2px;
  }

  .link-text {
    color: #b5b5c3;
  }
}
</style>
